import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { ConfluenceService } from '../../service';

export type PageExportConfig = typeof PageExportConfig._.Config;

export const PageExportConfig = IntegrationConfig.make({
  service: ConfluenceService,
  name: Integration_Handler_Names_Enum.PageExport,
  configSchema: z.object({
    pageId: z.number().positive(),
  }),
});
